export default __webpack_public_path__ + "static/article-what-to-do-when-you-have-car-accident-714c207776bdb67ca19756cb1ef46cda.jpg";